import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { menuList } from '../../recoil/atoms';
import NifiIcon from '../../assets/img/NiFiIcon_2_20.jpeg'
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  SvgIcon,
  Tooltip,

  IconButton,
} from '@mui/material';
import Routes from '../../routes';
import { useMediaQuery, createTheme } from '@mui/material';
import { ReactComponent as AppsIcon } from '../../assets/img/apps.svg';
import { plantId, UserSettings } from '../../recoil/atoms';


import { useNavigate, } from "react-router-dom";
const drawerWidth = 220;
function NavDrawer({ toggleDrawerOpen, open }) {
  const theme = createTheme(); // Create or import your theme object
  const matches = useMediaQuery(theme.breakpoints.up('sm'));


  const [, setMenu] = useRecoilState(menuList);
  const [userDet, setUserDet] = useState({});

  const [, setSelectedItem] = useState(null);
  const menu = useRecoilValue(menuList);
  const [PlantId, _] = useRecoilState(plantId);
  const navigate = useNavigate();
  const [userDataSettings, setUserDataSettings] = useRecoilState(UserSettings)
  const [isHovered, setIsHovered] = useState(false);
  const isExpanded = open || isHovered;
  useEffect(() => {
    try {
      let data = localStorage.getItem("user");
      let User = (data && data !== "undefined") ? JSON.parse(data) : null;
      setUserDet(User || {});
    } catch (e) {
      console.error("Error parsing user in LeftDrawer:", e);
      setUserDet({});
    }
  }, [userDataSettings]);
  useEffect(() => {
    toggleDrawerOpen(false);
  }, [matches]);

  const changeMenu = (name) => {
    setMenu(name);
    setSelectedItem(name);
  };
  const handleDashboardClick = () => {

    navigate(`/Analytics/${PlantId}`);
  };

  function getListItemSet(text, index) {
    const isSelected = menu === text.name;
    const textColor = isSelected ? '#fff' : '#475569';
    const backgroundColor = isSelected ? '#002060' : 'transparent';
    const iconColor = isSelected ? '#fff' : '#64748b';

    return text.icon ? (
      <NavLink key={index} style={{ textDecoration: 'none' }} to={text.path}>
        <ListItem
          disablePadding
          sx={{
            display: 'block',
            paddingLeft: 1.5,
            paddingRight: 1.5,
            paddingTop: 0.5,
            paddingBottom: 0.5,
            marginBottom: 0.5,
            position: 'relative'
          }}
          onClick={() => changeMenu(text.name)}
        >
          {isSelected && (
            <div className="absolute left-0 top-1.5 bottom-1.5 w-1.5 bg-indigo-500 rounded-r-full transition-all duration-300" />
          )}
          <ListItemButton
            sx={{
              minHeight: 50,
              justifyContent: isExpanded ? 'initial' : 'center',
              px: 2,
              borderRadius: '8px',
              backgroundColor: backgroundColor,
              '&:hover': {
                backgroundColor: isSelected ? '#001845' : '#f8fafc',
              },
              transition: 'all 0.25s cubic-bezier(0.16, 1, 0.3, 1)',
            }}
          >
            <SvgIcon style={{ color: iconColor, marginRight: isExpanded ? 12 : 0, transition: 'color 0.2s' }}>
              <Tooltip title={text.name} placement="right">
                <text.icon />
              </Tooltip>
            </SvgIcon>
            {isExpanded && (
              <ListItemText
                className="Drawer-ListItemText"
                primary={text.name === 'Logout' ? 'Logout' : text.name}
                sx={{ 
                  opacity: 1,
                  '& .MuiTypography-root': {
                    fontWeight: isSelected ? 600 : 500,
                    fontSize: '14px',
                    color: textColor
                  }
                }}
              />
            )}
            <ListItemText
              className="Dashboardpage"
              primary={handleDashboardClick}
              sx={{ display: 'none' }}
            />
          </ListItemButton>
        </ListItem>
      </NavLink>
    ) : null;
  }

  const drawer = (
    <List sx={{
      '& .MuiListItem-gutters': {
        padding: '0 5px',
        maxHeight: '45px',
      },
      '& a.active .MuiListItem-gutters .MuiListItemButton-gutters': {
        color: '#fff',
        background: '#002060',
        borderRadius: '10px',
        minHeight: '45px',
      },
      '& .MuiListItem-gutters  .MuiListItemButton-gutters': {
        padding: '0 10px',
        minHeight: '45px',
      },
      '& a.active .MuiListItem-gutters .MuiListItemButton-gutters .MuiSvgIcon-root svg': {
        color: '#fff!important'
      },
      '& a.active .MuiListItem-gutters .MuiListItemButton-gutters .Drawer-ListItemText': {
        color: '#fff!important'
      },
    }}>
      {Routes.mainRoutes.map((text, index) =>
        (text.name !== "Settings" || (userDet && (userDet.role_id === 1 || userDet.role_id === 3))) ? (
          getListItemSet(text, index)
        ) : null
      )}
    </List>
  );

  return (
    <>
      <Drawer
        className='desktop-view'
        variant={matches ? 'permanent' : 'persistent'}
        sx={{
          whiteSpace: 'nowrap',
          width: open ? drawerWidth : '70px',
          position: 'relative',
          transition: 'width 0.2s ease-in-out',
          '& .MuiDrawer-paper': {
            background: '#F7F7F8',
            width: isExpanded ? drawerWidth : '70px',
            transition: 'width 0.2s ease-in-out',
            overflowX: 'hidden',
            boxShadow: isHovered && !open ? '4px 0 10px rgba(0,0,0,0.1)' : 'none',
          },
        }}
        open={open}
        PaperProps={{
          onMouseLeave: () => setIsHovered(false),
        }}
      >
        <List disablePadding>
          <ListItem disablePadding>
            <ListItemButton
              disableRipple={matches}
              sx={{
                justifyContent: isExpanded ? 'initial' : 'center',
                px: 2,
                cursor: matches ? 'default' : 'pointer',
                '&:hover': {
                  backgroundColor: matches ? 'transparent' : 'rgba(0, 0, 0, 0.04)'
                }
              }}
              onClick={matches ? undefined : toggleDrawerOpen}
              onMouseEnter={() => {
                if (matches) {
                  setIsHovered(true);
                }
              }}
            >
              <IconButton
                color="inherit"
                aria-label="toggle drawer"
                sx={{ display: 'block', cursor: matches ? 'default' : 'pointer', width: 46, height: 46, ml: 0.5 }}
                disableRipple={matches}
              >
                <AppsIcon style={{ marginTop: '3px' }} />
              </IconButton>
              {isExpanded && <ListItemText sx={{ opacity: 1, color: '#000', fontWeight: '600', ml: 1.5 }} >NiFi Application</ListItemText>}
            </ListItemButton>
          </ListItem>
          {drawer}
          {/* SIDEBAR LIST OF ICONS BOTTOM*/}
          <List>
            {Routes.mainRoutes.map((text, index) =>
              text.footer && text.iconFlag ? getListItemSet(text, index) : null
            )}
          </List>
        </List>
      </Drawer>
      <Drawer
        variant="persistent"
        className='mobile-view'
        style={{
          whiteSpace: 'nowrap',
          position: 'fixed',
          width: open ? '220px' : '0',
          left: '0',
          top: '0',
          height: '100%',
          zIndex: 9999,
        }}
        open={open}
      >
        <List>
          <ListItem disablePadding>
            <ListItemButton
              sx={{
                minHeight: 58,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5
              }}
              onClick={toggleDrawerOpen}
            >
              <IconButton
                color="inherit"
                aria-label="toggle drawer"
                sx={{ display: 'block', cursor: 'pointer', width: 48, height: 48, ml: 0.5 }}
              >
                <AppsIcon />
              </IconButton>
              {open && <ListItemText primary="NiFi Application" sx={{ opacity: 1, ml: 1.5 }} style={{ color: 'black' }} />}
            </ListItemButton>
          </ListItem>
          {drawer}
          {/* SIDEBAR LIST OF ICONS BOTTOM*/}
          <List>
            {Routes.mainRoutes.map((text, index) =>
              text.footer && text.iconFlag ? getListItemSet(text, index) : null
            )}
          </List>
        </List>
      </Drawer>
    </>
  );
}
export default NavDrawer;